exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.link[data-v-3ec72ede] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin: 5px 20px;\n  text-decoration: none;\n  color: #D8D8D8;\n}\n.link .icon[data-v-3ec72ede] {\n    margin-right: 8px;\n}\n.link[data-v-3ec72ede]:hover {\n  color: #50aadb;\n}\n.link:hover .icon[data-v-3ec72ede] {\n    fill: #50aadb;\n}\n@media all and (max-width: 760px) {\n.link[data-v-3ec72ede] {\n    margin: 5px 10px;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?{"id":"data-v-3ec72ede","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/postcss-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/footer/Link.vue
// module id = 362
// module chunks = 0